<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-form-group
          label="İşlem Tarihi"
          label-for="dates"
        >
          <b-input-group>
            <b-form-datepicker
              id="sdate"
              v-model="filterParams.sdate"
              v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
            <b-input-group-addon is-text>
              -
            </b-input-group-addon>
            <b-form-datepicker
              id="edate"
              v-model="filterParams.edate"
              v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
      >
        <div class="d-flex justify-content-between">
          <b-button
            variant="gradient-primary"
            class="mr-1"
            @click="getReport"
          >
            <FeatherIcon icon="FilterIcon" />
            Raporu Görüntüle
          </b-button>
          <div>
            <b-button
              variant="gradient-success"
              class="mr-1"
              :href="exportExcel"
              target="_blank"
            >
              <FeatherIcon icon="DownloadIcon" />
              Rapor Özeti
            </b-button>
            <b-button
              variant="gradient-success"
              :href="exportDetailExcel"
              target="_blank"
            >
              <FeatherIcon icon="DownloadIcon" />
              Hesap Hareketleri
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BFormDatepicker, BFormGroup, BInputGroup, BInputGroupAddon, BButton,
} from 'bootstrap-vue'

export default {
  name: 'FilterCard',
  components: {
    BCard,
    BRow,
    BCol,
    BFormDatepicker,
    BFormGroup,
    BInputGroup,
    BInputGroupAddon,
    BButton,
  },
  props: {
    getReport: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['expensesReports/filterParams']
    },
    exportExcel() {
      const downloadToken = localStorage.getItem('downloadToken')
      let url = this.$store.state.app.baseURL
      url += `/Exports/reports/expenses?token=${downloadToken}`
      if (this.filterParams.sdate) {
        url += `&sdate=${this.filterParams.sdate}`
      }
      if (this.filterParams.sdate) {
        url += `&edate=${this.filterParams.edate}`
      }
      return url
    },
    exportDetailExcel() {
      const downloadToken = localStorage.getItem('downloadToken')
      let url = this.$store.state.app.baseURL
      url += `/Exports/reports/expenses/detail?token=${downloadToken}`
      if (this.filterParams.sdate) {
        url += `&sdate=${this.filterParams.sdate}`
      }
      if (this.filterParams.sdate) {
        url += `&edate=${this.filterParams.edate}`
      }
      return url
    },
  },
}
</script>
